/**
 *
 * @param race
 * @param proficiencyLookup
 * @param abilityLookup
 * @param characterLevel
 */
export function generatePrerequisiteData(race, proficiencyLookup, abilityLookup, characterLevel) {
    return {
        race,
        proficiencyLookup,
        abilityLookup,
        characterLevel,
    };
}
